import React from 'react'
import {
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";



class DataTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  // render each row details
  createRow = row => {
    let keys = Object.keys(row);

    return keys.map((key) => {
      return (
        <td key={key}>{row[String(key)]}</td>
      );
    });
  };

  formatTime(dateString) {
    var date = new Date(dateString);
    return date.toLocaleDateString()
  };

  render() {
    const heads = this.props.heads;
    const dataAttributes = this.props.dataAttributes;
    const cols = heads.map((head) =>
      <th scope="col" key={head}>{head}</th>
    );

    const rows = this.props.rows;
    const data = rows.map((row) =>
      <tr key={row.id}>
        <td key={`user-${row.id}-note`}>{`${row['note']}`}</td>

        <td key={`user-${row.id}-displayname`}>{row['category'] ? row['category']['display_name'] : '訂閱推送'}</td>
        <td key={`user-${row.id}-user`}>{`${row['user']['name']}`}</td>
        <td key={`user-${row.id}-action`}>{`${row['action']}`}</td>
        <td key={`user-${row.id}-created_at`}>{`${row['created_at']}`}</td>
      </tr >
    )



    return (
      <OverlayLoading loading={this.props.loading}>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              {cols}
            </tr>
          </thead>
          <tbody>
            {data}
          </tbody>
        </Table>
      </OverlayLoading>
    );
  }

}



export default DataTable